import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    backgroundColor: palette.common.white,
    padding: '20px 20px 0',
    marginBottom: -15,
  },
  button: {
    fontFamily: 'Lato',
    display: 'inline-block',
    background: 'transparent',
    border: 'none',
    padding: 0,
    color: custom.grey[3],
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));
